import React, { useEffect, useRef } from "react";
import { isNative, AD_IDS, USE_TEST_ADS } from "../services/AdMobService";

function BannerNativo({ position = "bottom" }) {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;

    // Delay de 2s para garantir que AdMob inicializou
    const timer = setTimeout(async () => {
      try {
        const { AdMob, BannerAdSize, BannerAdPosition } = await import(
          "@capacitor-community/admob"
        );
        const posicao = position === "top"
          ? BannerAdPosition.TOP_CENTER
          : BannerAdPosition.BOTTOM_CENTER;

        await AdMob.showBanner({
          adId: AD_IDS.banner,
          adSize: BannerAdSize.ADAPTIVE_BANNER,
          position: posicao,
          margin: 0,
          isTesting: USE_TEST_ADS,
        });
        console.log("[AdBanner] Banner exibido");
      } catch (err) {
        console.warn("[AdBanner] Erro:", err);
      }
    }, 2000);

    return () => {
      clearTimeout(timer);
      (async () => {
        try {
          const { AdMob } = await import("@capacitor-community/admob");
          await AdMob.removeBanner();
        } catch (_) {}
      })();
    };
  }, [position]);

  // Espaçador para o conteúdo não ficar atrás do banner
  return <div style={{ height: 60, width: "100%", flexShrink: 0 }} />;
}

function BannerPlaceholder({ style = {} }) {
  return (
    <div style={{
      width: "100%", maxWidth: 480, minHeight: 50,
      background: "var(--bg-elevated)", border: "1px dashed var(--border)",
      borderRadius: 10, display: "flex", alignItems: "center",
      justifyContent: "center", color: "var(--text-muted)",
      fontSize: "0.72rem", fontFamily: "'Space Mono'",
      letterSpacing: "0.04em", margin: "0 auto", ...style,
    }}>
      PUBLICIDADE
    </div>
  );
}

export default function AdBanner({ hideOnWeb = false, style = {}, position = "bottom" }) {
  if (!isNative()) {
    if (hideOnWeb) return null;
    return <BannerPlaceholder style={style} />;
  }
  return <BannerNativo position={position} />;
}
